// cart drawer start
let cart_drawer = document.getElementById("sidebar-cart");
let cart_drawer_content = document.querySelector(
  '[data-armada-selector="cart-drawer-selector"] #drawer-cart-content'
);
let drawer_overlay = document.getElementById("drawer-overlay");
let cart_icon = document.querySelector("[data-action='open-cart-drawer']");
let close_cart_drawer = document.querySelector(
  '[data-action="close-drawer"][data-drawer-id="sidebar-cart"]'
);


const handleDrawerOpenChanges = (z, opacity, overflowElem, overflowVal) => {
  drawer_overlay.style.zIndex = z;
  drawer_overlay.style.opacity = opacity;
  overflowElem.style.overflow = overflowVal;
};
function openDrawer(e) {
  e.preventDefault();
  cart_drawer.setAttribute("aria-hidden", "false");
  handleDrawerOpenChanges(200, 0.5, document.body, "hidden");
}
function closeDrawer(e) {
  e.preventDefault();
  cart_drawer.setAttribute("aria-hidden", "true");
  handleDrawerOpenChanges(-1, 0, document.body, "auto");
}
const keydownHandler = function (event) {
  if (event.key === "Escape" || event.keyCode === 27) {
    closeDrawer(event);
  }
};
const handleToggleDrawer = () => {
  if (cart_drawer.getAttribute("aria-hidden") == "true") {
    handleDrawerOpenChanges(200, 0.5, document.body, "hidden");
  } else {
    handleDrawerOpenChanges(-1, 0, document.body, "auto");
  }
};
let safeAreaListenerAdded = false;
const fetchCartDrawer = (openDrawer) => {
  fetch("/?view=cart")
    .then((res) => res.text())
    .then((html) => {
      if (!window.location.href.includes("/cart")) {
        cart_drawer_content.innerHTML = html;
      }

      if (!window.location.href.includes("/cart")) {
        const cartItems = cart_drawer_content.querySelectorAll(".cart-line-item");
        const checkoutBtn = cart_drawer_content.querySelector('[data-aid="checkout-button-drawer"]');
      } else {
        const cartItems = document.querySelectorAll(".cart-line-item");
        const checkoutBtn = document.querySelector('[data-aid="checkout-button"]');
      }

      const onlyLensOrWarranty =
        cartItems.length > 0 &&
        Array.from(cartItems).every((item) => {
          const type = item.dataset.productType;
          return type === "LensAdvizor" || type === "Warranty";
        });

      if (onlyLensOrWarranty && checkoutBtn) {
        checkoutBtn.style.pointerEvents = "none";
        checkoutBtn.style.backgroundColor = "#666666";
        checkoutBtn.style.borderColor = "#666666";
      }

      openDrawer && cart_drawer.setAttribute("aria-hidden", "false");
    });
};

document.addEventListener("keydown", keydownHandler, false);
cart_icon?.addEventListener("click", (e) => openDrawer(e));
close_cart_drawer?.addEventListener("click", (e) => closeDrawer(e));
!window.location.href.includes("/cart") && drawer_overlay.addEventListener("click", (e) => closeDrawer(e));
// cart drawer end

const isMobileDevice =
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

const onWindowLoad = () => {
  fetchCartDrawer();

  let clickable_copy_code = document.querySelectorAll('.clickable-copy-code');

  clickable_copy_code.forEach((element) => {
    let code = element.querySelector('strong, b');
    let copy_icon = element.querySelector('#copy-icon');
    let check_icon = element.querySelector('#copy-check-icon');

    element.addEventListener('click', () => {
      navigator.clipboard.writeText(code.innerText);
      copy_icon.classList.add('icon-hidden');
      check_icon.classList.remove('icon-hidden');

      setTimeout(() => {
        check_icon.classList.add('icon-hidden');
        copy_icon.classList.remove('icon-hidden');
      }, 2000);
    });
  });
};

window.addEventListener("load", onWindowLoad, { passive: true });

// footer show/hide footer navigation list
const footer_titles = document.getElementsByClassName(
  "footer__heading-container"
);
const footer_navigation_ul = document.getElementsByClassName(
  "footer__navigation-ul"
);
const footer_navigation_plus_icon =
  document.getElementsByClassName("footer__plus-icon");

let result;

for (let i = 0; i < footer_titles.length; i++) {
  for (let j = 0; j < footer_navigation_ul.length; j++) {
    let title = footer_titles[i];
    let ul = footer_navigation_ul[j];
    let icon = footer_navigation_plus_icon[i];

    if (title.id == ul.getAttribute("data-id")) {
      isMobileDevice &&
        title.addEventListener(
          "click",
          () => {
            if (ul.style.display == "block") {
              ul.style.display = "none";
              icon.style.transform = "rotate(0deg)";
            } else {
              ul.style.display = "block";
              icon.style.transform = "rotate(45deg)";
            }
          },
          { passive: true }
        );
    }
  }
}

// Warranty Logic Start
// window.addEventListener("load", (event) => {
//   let warranty_check = document.getElementById("add-warranty");
//   if (
//     window.location.href.includes("/products/") &&
//     current_product.type.includes("sunglasses")
//   ) {
//     warranty_check.addEventListener("click", (e) => {
//       if (e.target.checked) {
//         localStorage.setItem(
//           "warrantySelected",
//           window.variantStrings.productId
//         );
//       } else {
//         localStorage.setItem("warrantySelected", e.target.checked);
//       }
//     });
//   }
// });


const filter_pills = document.querySelectorAll('.filter-pill');
if(filter_pills){
  Array.from(filter_pills).forEach(btn => {
    btn.addEventListener("click", (e) => {
      Array.from(filter_pills).forEach(btn => {
        btn.classList.remove('active')
      })
      e.target.classList.add('active')
    })
  })
}


(async () => {
  const links = document.querySelectorAll('.eu-withdrawal-link');
  if (!links.length) return;

  const EU_COUNTRIES = new Set([
    'AT','BE','BG','HR','CY','CZ','DE','DK','EE','ES','FI',
    'FR','GR','HU','IE','IT','LT','LU','LV','MT','NL','PL',
    'PT','RO','SE','SI','SK'
  ]);

  try {
    const res = await fetch('https://ipapi.co/json/');
    const { country_code } = await res.json();
    if (EU_COUNTRIES.has(country_code)) {
      links.forEach(el => el.style.display = 'block');
    }
  } catch (e) {
    // fail silently — link stays hidden
  }
})();

(function () {
  const SELECTOR =
    '[data-shg-product-target="product-title"], .shg-product-title-component';
  const HAS_WORD = /\b(Eyeglasses|Sunglasses)\b/;
  const WORDS = /\b(Eyeglasses|Sunglasses)\b/g;

  function cleanTitles() {
    document.querySelectorAll(SELECTOR).forEach(el => {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (HAS_WORD.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue
            .replace(WORDS, '')
            .replace(/\s{2,}/g, ' ')
            .trim();
        }
      }
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      cleanTitles();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();